(function () {
  const banner = document.querySelector('.weekly-cart-limit-banner');
  if (!banner) return; // only run on pages with the banner

  const WEEKLY_LIMIT = Number(banner.dataset.weeklyLimit || 3);

  function getWeeklyUsed() {
    // pull fresh value (Liquid-rendered) in case the DOM is re-rendered
    const b = document.querySelector('.weekly-cart-limit-banner');
    return Number((b && b.dataset.weeklyUsed) || 0);
  }

  function getCheckoutButtons() {
    return document.querySelectorAll('button[name="checkout"], a[href*="/checkout"]');
  }

  function setCheckoutBlocked(blocked) {
    getCheckoutButtons().forEach(btn => {
      btn.disabled = blocked;
      btn.style.pointerEvents = blocked ? 'none' : '';
      btn.style.opacity = blocked ? '0.45' : '';
      btn.style.cursor = blocked ? 'not-allowed' : '';
    });
  }

  async function refreshCartLimit() {
    // Only run if cart UI exists
    const hasCart =
      document.querySelector('cart-items') ||
      document.querySelector('form[action^="/cart"]') ||
      document.querySelector('#CartDrawer');

    if (!hasCart) return;

    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();

      const WEEKLY_USED = getWeeklyUsed();
      const cartQty = Number(cart.item_count || 0);
      const projectedTotal = WEEKLY_USED + cartQty;
      const blocked = projectedTotal > WEEKLY_LIMIT;

      setCheckoutBlocked(blocked);

      const banner = document.querySelector('.weekly-cart-limit-banner');
      if (banner) {
        // Always show banner
        banner.style.display = '';

        const weeklyRemaining = Math.max(0, WEEKLY_LIMIT - WEEKLY_USED);
        const overBy = Math.max(0, projectedTotal - WEEKLY_LIMIT);

        // IMPORTANT: your Liquid banner currently DOES NOT have these sub-elements/classes,
        // so only try to update them if you add them.
        const titleEl = banner.querySelector('.weekly-banner-title');
        const remainingEl = banner.querySelector('.js-weekly-remaining');
        const pluralEl = banner.querySelector('.js-weekly-plural');
        const actionEl = banner.querySelector('.weekly-banner-action');
        const overByEl = banner.querySelector('.js-weekly-overby');
        const overByPluralEl = banner.querySelector('.js-weekly-overby-plural');

        if (remainingEl) remainingEl.textContent = String(weeklyRemaining);
        if (pluralEl) pluralEl.textContent = weeklyRemaining === 1 ? '' : 's';
        if (overByEl) overByEl.textContent = String(overBy);
        if (overByPluralEl) overByPluralEl.textContent = overBy === 1 ? '' : 's';

        if (blocked) {
          if (titleEl) titleEl.textContent = 'Weekly limit reached';
          if (actionEl) actionEl.style.display = '';
          banner.style.borderColor = '#d72c0d';
          banner.style.background = '#fff4f4';
        } else {
          if (titleEl) titleEl.textContent = 'Weekly purchase limit';
          if (actionEl) actionEl.style.display = 'none';
          banner.style.borderColor = '#d0d5dd';
          banner.style.background = '#f8fafc';
        }
      }
    } catch (e) {
      // fail open
      setCheckoutBlocked(false);
    }
  }

  // Initial run
  refreshCartLimit();

  document.addEventListener('change', (e) => {
    if (e.target && e.target.name === 'updates[]') {
      setTimeout(refreshCartLimit, 200);
    }
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('.quantity') || e.target.closest('#CartDrawer')) {
      setTimeout(refreshCartLimit, 200);
    }
  });

  new MutationObserver(() => {
    clearTimeout(window.__weeklyCartTimer);
    window.__weeklyCartTimer = setTimeout(refreshCartLimit, 300);
  }).observe(document.body, { childList: true, subtree: true });

})();